import { ColumnChart, GraduationCap, Groups } from 'assets/Icons'
import Users from 'assets/Icons/Users'
import SwitchTheme from 'layout/SwitchTheme'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import NavMenu from './NavMenu'
const StyledSidebar = styled.div`
	height: 100%;
	overflow-x: hidden;
	overflow-y: scroll;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	&::-webkit-scrollbar {
		width: 100%;
	}
	& .menu-list {
		display: flex;
		flex-direction: column;
		margin: 0;
		min-width: 100%;
		padding: 6px 8px;
		width: 100%;
	}
`
const Sidebar = ({ isLargeWindow }) => {
	const translation = useTranslation()
	const language = translation?.i18n?.language
	const collapsed = useSelector(state => state.ui?.sidebarCollapsed)
	const role = useSelector(state => state?.user?.user?.user_type)
	const [activeIndex, setActiveIndex] = useState(-1)
	const routes = useMemo(() => {
		const newSidebar = [
			{
				icon: <ColumnChart />,
				label_en: 'Dashboard',
				label_ru: 'Дашбоард',
				label_uz: 'Dashboard',
				path: '/account/dashboard',
				permission: ['admin', 'accountant'],
			},
			{
				icon: <Groups />,
				label_en: 'Groups',
				label_ru: 'Группы',
				label_uz: 'Guruhlar',
				path: '/account/groups',
				permission: ['admin', , 'accountant', 'teacher', 'student'],
			},
			{
				icon: <Users />,
				label_en: 'Teachers',
				label_ru: 'Учителя',
				label_uz: "O'qituvchilar",
				path: '/account/teachers',
				permission: ['admin', 'accountant'],
			},
			{
				icon: <GraduationCap />,
				label_en: 'Students',
				label_ru: 'Ученики',
				label_uz: "O'quvchilar",
				path: '/account/students',
				permission: ['admin', 'accountant'],
			},
		]
		const memoizedSidebar = newSidebar.map(sidebar => {
			const children = sidebar?.children
			const newChildren = Array.isArray(children)
				? children.map(child => ({
						...child,
						label: child?.['label_' + language],
				  }))
				: []
			return {
				...sidebar,
				children: newChildren,
				label: sidebar?.['label_' + language],
			}
		})
		return memoizedSidebar
	}, [language])
	return (
		<StyledSidebar>
			<ul className='menu-list'>
				{routes.map(
					(route, index) =>
						route?.permission?.includes(role) && (
							<NavMenu
								{...route}
								index={index}
								key={index}
								setActiveIndex={setActiveIndex}
								activeIndex={activeIndex}
								collapsed={collapsed}
								isLargeWindow={isLargeWindow}
							/>
						)
				)}
			</ul>
			<div className='ml-auto block sm:hidden p-2'>
				<SwitchTheme />
			</div>
		</StyledSidebar>
	)
}
export default Sidebar
